import { render, staticRenderFns } from "./EditAssetLocalisationDialogComponent.vue?vue&type=template&id=0a6a0a8e&"
import script from "./EditAssetLocalisationDialogComponent.vue?vue&type=script&lang=js&"
export * from "./EditAssetLocalisationDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports